import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {HEADER_HEIGHT_MOBILE} from 'components/Layouts/mobileStyles'
import {SearchProgressBar} from 'components/SearchProgressBar'
import {getDateValidationReason} from 'modules/search/selectors'
import {setIsTopHeaderHidden} from 'modules/search/slice'
import {getIsSearchBoxOpen} from 'modules/searchBox/selectors'
import {useScroll} from 'motion/react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

import {
  MobileHeaderContent,
  MobileHeaderContentProps
} from './MobileHeaderContent'

// overflow: hidden was intentionally removed to allow the date validation
// tooltip to render outside the header bounds without being clipped
const HeaderWrapper = styled.div`
  position: relative;
`

export const MobileHeader: React.FC<MobileHeaderContentProps> = ({
  className,
  hasDivider,
  hasHeaderSearchSummary,
  hasHeaderBottomContent,
  hasHeaderMenu,
  hasSearchProgressBar,
  hasBackButton,
  headerTitle,
  page
}) => {
  const dispatch = useDispatch()
  const {shell} = useBrandCapabilities()

  const isSearchBoxOpen = useSelector(getIsSearchBoxOpen)
  const dateValidationReason = useSelector(getDateValidationReason)

  const {scrollY} = useScroll()

  useEffect(() => {
    if (shell.hasCollapsingHeader) {
      const unsubscribe = scrollY.on('change', v => {
        dispatch(setIsTopHeaderHidden(Boolean(v > HEADER_HEIGHT_MOBILE)))
      })
      return () => unsubscribe()
    }
  }, [scrollY, dispatch, shell.hasCollapsingHeader])

  useEffect(() => {
    if (shell.hasCollapsingHeader) {
      dispatch(setIsTopHeaderHidden(false))
    }
  }, [dispatch, shell.hasCollapsingHeader])

  return (
    <HeaderWrapper className={className}>
      <MobileHeaderContent
        hasDivider={hasDivider}
        hasHeaderSearchSummary={hasHeaderSearchSummary}
        hasHeaderBottomContent={hasHeaderBottomContent}
        hasHeaderMenu={hasHeaderMenu}
        hasBackButton={hasBackButton}
        headerTitle={headerTitle}
        page={page}
      />
      {hasSearchProgressBar && !isSearchBoxOpen && (
        <SearchProgressBar mobileTooltipVisible={!!dateValidationReason} />
      )}
    </HeaderWrapper>
  )
}
